import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { authService } from '@/services/authService'
import type { User } from '@/types'

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | null>(localStorage.getItem('token'))
  const user = ref<User | null>(null)
  const loading = ref(false)

  const isAuthenticated = computed(() => !!token.value && !!user.value)
  const isAdmin = computed(() => user.value?.admin ?? false)

  async function login(username: string, password: string): Promise<void> {
    loading.value = true
    try {
      const response = await authService.login({ username, password })
      token.value = response.token
      localStorage.setItem('token', response.token)
      await fetchUser()
    } finally {
      loading.value = false
    }
  }

  async function fetchUser(): Promise<void> {
    if (!token.value) return
    try {
      user.value = await authService.me()
    } catch {
      logout()
    }
  }

  async function checkAuth(): Promise<void> {
    if (token.value) {
      await fetchUser()
    }
  }

  function logout(): void {
    token.value = null
    user.value = null
    localStorage.removeItem('token')
  }

  return {
    token,
    user,
    loading,
    isAuthenticated,
    isAdmin,
    login,
    fetchUser,
    checkAuth,
    logout
  }
})
